module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrapper"
  }, [(!_vm.isClosed) ? _c('div', {
    staticClass: "popup-wrapper"
  }, [_c('div', {
    staticClass: "popup-dialog"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("打开壹钱包APP")]), _vm._v(" "), _c('div', {
    staticClass: "btn-box"
  }, [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.closePage
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.callApp
    }
  }, [_c('strong', [_vm._v("确定")])])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5637384"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 29
// module chunks = 1